<template>
    <FloatingPanel title="Webshop product" :width="400">
        <div class="shop-canvas-blocks-modules-shop-BlockPanel">
            <Tabs :tabs="['Product', 'Algemeen']">
                <div slot="Product">
                    <div class="m-5">
                        <small class="block mb-3 text-gray-500">
                            Kies het product dat op deze pagina besteld kan worden. Producten beheer je in het menu onder Webshop.
                        </small>

                        <v-select
                            :options="products"
                            label="name"
                            v-model="options.product_id"
                            :reduce="product => product.id"
                            append-to-body
                        >
                            <div slot="no-options">Nog geen producten aangemaakt</div>
                        </v-select>
                    </div>
                </div>

                <div slot="Algemeen">
                    <CommonInputs :options="options" />
                </div>
            </Tabs>
        </div>
    </FloatingPanel>
</template>

<script>
import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

    data() {
        return {
            products: [],
        };
    },

    created() {
        this.loadProducts();
    },

    methods: {
        async loadProducts() {
            this.products = (await axios.get(this.adminUrlPrefix + '/products')).data;
        },
    },
};
</script>
